class Workers {

    constructor(_request) {
        this._request = _request;
    }

    list() {
        return this._request.fetch({method: "GET", endpoint: "workers"});
    }
    
    instances(_username) {
        return this._request.fetch({method: "POST", endpoint: "workers/instances", params: {username: _username}});
    }

    online() {
        return this._request.fetch({method: "GET", endpoint: "workers/online"});
    }
}

export default Workers;
